<div class="hd-throat-voices">
  <header class="hd-throat-voices__header">
    <h3 class="hd-throat-voices__title">{{ vm().title }}</h3>
  </header>

  <!-- Keelcentrum-noot van de cheat sheet -->
  @if (vm().note) {
    <p class="hd-throat-voices__text">{{ vm().note }}</p>
  }

  <!-- Voice-blokjes + wiel-diagram; klikken springt naar de detailsectie -->
  <div class="hd-throat-voices__hero">
    <div class="hd-throat-voices__cards">
      @for (gate of gates; track gate) {
        <button
          type="button"
          class="hd-throat-voices__card-button"
          [attr.data-hero-gate]="gate"
          [title]="vm().jumpHint"
          (click)="scrollToGate(gate)">
          <hd-voice-card [gate]="gate" size="compact" />
        </button>
      }
    </div>
    <img class="hd-throat-voices__wheel" [src]="wheelAsset" [alt]="vm().title" (load)="onWheelLoad()" />
  </div>

  <!-- Per groep de voices, met het groeps-aandachtspunt en de -oplossing -->
  <div class="hd-throat-voices__groups">
    @for (group of vm().groups; track group.key) {
      <section class="hd-throat-voices__group" [attr.data-voice-group]="group.key">
        @if (group.hasHeader) {
          <div class="hd-throat-voices__group-header">
            @if (group.title) {
              <h4 class="hd-throat-voices__group-title">{{ group.title }}</h4>
            }
            @if (group.subtitle) {
              <p class="hd-throat-voices__group-subtitle">{{ group.subtitle }}</p>
            }
            @if (group.attention) {
              <p class="hd-throat-voices__group-point hd-throat-voices__group-point--attention">
                <span class="hd-throat-voices__group-point-label">{{ vm().attentionLabel }}:</span>
                {{ group.attention }}
              </p>
            }
            @if (group.solution) {
              <p class="hd-throat-voices__group-point hd-throat-voices__group-point--solution">
                <span class="hd-throat-voices__group-point-label">{{ vm().solutionLabel }}:</span>
                {{ group.solution }}
              </p>
            }
          </div>
        }
        @for (gate of group.gates; track gate) {
          <hd-voice-section class="hd-throat-voices__section" [gate]="gate" cardSize="compact" />
        }
      </section>
    }
  </div>
</div>
